<template>
  <div class="wrapper">
    <div class="closeBtn">
      <feather-icon icon="XIcon" @click="closePage" />
    </div>
    <div class="title">
      <h1>Formação</h1>
    </div>
    <div class="content">
      <ValidationObserver
        ref="observer"
        tag="form"
        v-slot="{ invalid, dirty }"
        @submit.prevent="submit()"
      >
        <vs-row>
          <div class="group">
            <ValidationProvider
              name="escolaridade"
              rules="required"
              v-slot="{ errors }"
            >
              <vs-col vs-sm="12" vs-lg="6">
                <label class="vs-select--label">Escolaridade</label>
                <v-select
                  class="mb-1"
                  :options="scholarities"
                  :reduce="scholarity => scholarity.value"
                  v-model="payload.scholarity"
                >
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!payload.scholarity"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-select>
                <span class="text-danger">
                  {{ errors[0] }}
                </span>
              </vs-col>
            </ValidationProvider>

            <ValidationProvider
              name="escolaridade"
              rules="required"
              v-slot="{ errors }"
            >
              <vs-col vs-sm="12" vs-lg="6">
                <label class="vs-select--label">Status</label>
                <v-select
                  class="mb-1"
                  name="level"
                  :options="levels"
                  :reduce="level => level.value"
                  v-model="payload.level"
                >
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!payload.level"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-select>
                <span class="text-danger">
                  {{ errors[0] }}
                </span>
              </vs-col>
            </ValidationProvider>

            <ValidationProvider
              rules="required|monthYear"
              name="data_inicio"
              v-slot="{ errors }"
              mode="lazy"
            >
              <vs-col class="h-auto" vs-sm="12" vs-lg="6">
                <vs-input
                  ref="from_date"
                  class="w-full no-icon-border mb-1"
                  type="text"
                  label="Data de início"
                  placeholder="Mês e Ano"
                  v-mask="'##/####'"
                  v-model="payload.from_date"
                  description-text="Exemplo: 01/2006"
                  :danger="errors.length"
                />
                <span class="text-danger text-xs">
                  {{ errors[0] }}
                </span>
              </vs-col>
            </ValidationProvider>

            <ValidationProvider
              rules="required|monthYear"
              name="data_saida"
              v-slot="{ errors }"
              vid="confirmation"
              mode="lazy"
            >
              <vs-col vs-sm="12" vs-lg="6">
                <vs-input
                  class="w-full no-icon-border mb-1"
                  type="text"
                  :label="
                    payload.level == 'Em andamento'
                      ? 'Previsão de formação'
                      : 'Data de finalização'
                  "
                  placeholder="Mês e Ano"
                  v-mask="'##/####'"
                  v-model="payload.to_date"
                  description-text="Exemplo: 01/2006"
                  :danger="errors.length"
                />
                <span class="text-danger text-xs">
                  {{ errors[0] }}
                </span>
              </vs-col>
            </ValidationProvider>

            <vs-col vs-sm="12" vs-lg="6">
              <vs-input
                class="w-full no-icon-border mb-1"
                name="institute"
                type="text"
                label="Instituição"
                v-model="payload.institute"
              />
            </vs-col>

            <vs-col v-if="showCourse()" vs-sm="12" vs-lg="6">
              <label class="vs-select--label"
                >Curso
                <span class="instruction">
                  selecione ou insira um curso
                </span>
              </label>
              <ValidationProvider
                name="escolaridade"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  class="mb-1"
                  name="grade"
                  :options="higherEducation"
                  taggable
                  pushTags
                  v-model="payload.grade"
                >
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!payload.grade"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-select>
                <span class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </vs-col>

            <vs-col v-if="!showCourse()" vs-sm="12" vs-lg="6">
              <ValidationProvider name="grade" v-slot="{ errors, valid }">
                <vs-input
                  class="w-full no-icon-border mb-1"
                  :disabled="isDisabled()"
                  type="text"
                  label="Curso"
                  v-model="payload.grade"
                  :danger="!valid"
                  :danger-text="errors[0] || ''"
                />
              </ValidationProvider>
            </vs-col>

            <vs-col class="mt-5" vs-sm="12">
              <button
                :disabled="invalid"
                :style="
                  invalid
                    ? { opacity: 0.5, backgroundColor: color }
                    : { opacity: 1, backgroundColor: color }
                "
                class="mt-5 button"
                type="submit"
              >
                Salvar
              </button>
            </vs-col>
          </div>
        </vs-row>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { isBefore } from "date-fns";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { ModelSelect } from "vue-search-select";
import vSelect from "vue-select";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    ModelSelect,
    "v-select": vSelect
  },
  props: ["formation"],
  data: () => ({
    payload: {
      index: 0,
      popupActive: false,
      scholarity: "",
      institute: "",
      level: "",
      grade: "",
      to_date: "",
      from_date: ""
    },
    scholarities: [
      { value: "Curso Técnico", label: "Curso Técnico" },
      { value: "Ensino Fundamental", label: "Ensino Fundamental" },
      { value: "Ensino Médio", label: "Ensino Médio" },
      { value: "Ensino Técnico", label: "Ensino Técnico" },
      { value: "Ensino Superior", label: "Ensino Superior" },
      { value: "Pós Graduação", label: "Pós Graduação" },
      { value: "Mestrado", label: "Mestrado" },
      { value: "Doutorado", label: "Doutorado" },
      { value: "Pós Doutorado", label: "Pós Doutorado" },
      { value: "Outros Cursos", label: "Outros Cursos" }
    ],
    levels: [
      { value: "Incompleto", label: "Incompleto" },
      { value: "Em andamento", label: "Em andamento" },
      { value: "Completo", label: "Completo" }
    ],
    higherEducation: [
      "Administração",
      "Administração Pública",
      "Agrimensura",
      "Agroecologia",
      "Agronegócios e Agropecuária",
      "Agronomia",
      "Alimentos",
      "Análise e Desenvolvimento de Sistemas",
      "Animação",
      "Aquicultura",
      "Arqueologia",
      "Arquitetura e Urbanismo",
      "Arquivologia",
      "Artes",
      "Artes Visuais - Bacharelado",
      "Artes Visuais - Licenciatura",
      "Astronomia",
      "Automação Industrial",
      "Banco de Dados",
      "Biblioteconomia",
      "Biocombustíveis",
      "Biomedicina",
      "Biossistemas",
      "Biotecnologia",
      "Biotecnologia e Bioquímica",
      "Ciência da Computação",
      "Ciência da Terra",
      "Ciência e Economia",
      "Ciência e Tecnologia",
      "Ciência e Tecnologia das Águas/do Mar",
      "Ciência e Tecnologia de Alimentos",
      "Ciências Aeronáuticas",
      "Ciências Agrárias",
      "Ciências Atuariais",
      "Ciências Biológicas",
      "Ciências Contábeis",
      "Ciências da Natureza e suas Tecnologias",
      "Ciências do Consumo",
      "Ciências Econômicas",
      "Ciências Humanas",
      "Ciências Naturais",
      "Ciências Sociais",
      "Cinema e Audiovisual",
      "Comércio Exterior",
      "Computação",
      "Comunicação das Artes do Corpo",
      "Comunicação em Mídias Digitais",
      "Comunicação Institucional",
      "Comunicação Organizacional",
      "Conservação e Restauro",
      "Construção Civil",
      "Construção Naval",
      "Cooperativismo",
      "Cultura, Linguagens e Tecnologias Aplicadas",
      "Dança",
      "Defesa e Gestão Estratégica Internacional",
      "Design",
      "Design de Games",
      "Design de Interiores",
      "Design de Moda",
      "Direito",
      "Ecologia",
      "Educação Física",
      "Educomunicação",
      "Eletrônica Industrial",
      "Eletrotécnica Industrial",
      "Energia e Sustentabilidade",
      "Energias Renováveis",
      "Enfermagem",
      "Engenharia Acústica",
      "Engenharia Aeronáutica",
      "Engenharia Agrícola",
      "Engenharia Ambiental e Sanitária",
      "Engenharia Biomédica",
      "Engenharia Bioquímica e de Biotecnologia",
      "Engenharia Cartográfica e de Agrimensura",
      "Engenharia Civil",
      "Engenharia de Alimentos",
      "Engenharia de Bioprocessos",
      "Engenharia de Biossistemas",
      "Engenharia de Computação",
      "Engenharia de Controle e Automação",
      "Engenharia de Energia",
      "Engenharia de Fortificação e Construção",
      "Engenharia de Inovação",
      "Engenharia de Materiais",
      "Engenharia de Minas",
      "Engenharia de Pesca",
      "Engenharia de Petróleo",
      "Engenharia de Produção",
      "Engenharia de Segurança no Trabalho",
      "Engenharia de Sistemas",
      "Engenharia de Software",
      "Engenharia de Telecomunicações",
      "Engenharia de Transporte e da Mobilidade",
      "Engenharia Elétrica",
      "Engenharia Eletrônica",
      "Engenharia Física",
      "Engenharia Florestal",
      "Engenharia Hídrica",
      "Engenharia Industrial Madeireira",
      "Engenharia Mecânica",
      "Engenharia Mecânica de Armamentos",
      "Engenharia Mecânica de Veículos Militares",
      "Engenharia Mecatrônica",
      "Engenharia Metalúrgica",
      "Engenharia Naval",
      "Engenharia Nuclear",
      "Engenharia Química",
      "Engenharia Têxtil",
      "Escrita Criativa",
      "Esporte",
      "Estatística",
      "Estética e Cosmética",
      "Estudos de Gênero e Diversidade",
      "Estudos de Mídia",
      "Eventos",
      "Fabricação Mecânica",
      "Farmácia",
      "Filosofia",
      "Física",
      "Fisioterapia",
      "Fonoaudiologia",
      "Fotografia",
      "Gastronomia",
      "Geofísica",
      "Geografia",
      "Geologia",
      "Geoprocessamento",
      "Gerontologia",
      "Gestão Ambiental",
      "Gestão Comercial",
      "Gestão da Informação",
      "Gestão da Produção Industrial",
      "Gestão da Qualidade",
      "Gestão da Tecnologia da Informação",
      "Gestão de Cooperativas",
      "Gestão de Recursos Humanos",
      "Gestão de Segurança Privada",
      "Gestão de Seguros",
      "Gestão de Turismo",
      "Gestão Desportiva e de Lazer",
      "Gestão em Saúde",
      "Gestão Financeira",
      "Gestão Hospitalar",
      "Gestão Pública",
      "História",
      "História da Arte",
      "Hotelaria",
      "Humanidades",
      "Informática",
      "Informática Biomédica",
      "Irrigação e Drenagem",
      "Jogos Digitais",
      "Jornalismo",
      "Letras em Língua Estrangeira",
      "Letras em Língua Portuguesa",
      "Libras",
      "Linguagens e Códigos e suas Tecnologias",
      "Linguística",
      "Logística",
      "Luteria",
      "Manutenção de Aeronaves",
      "Manutenção Industrial",
      "Marketing",
      "Matemática",
      "Matemática e Computação e suas Tecnologias",
      "Materiais",
      "Mecatrônica Industrial",
      "Medicina",
      "Medicina Veterinária",
      "Meteorologia",
      "Mineração",
      "Museologia",
      "Música",
      "Musicoterapia",
      "Nanotecnologia",
      "Naturologia",
      "Negócios Imobiliários",
      "Nutrição",
      "Obstetrícia",
      "Oceanografia",
      "Odontologia",
      "Oftálmica",
      "Optometria",
      "Papel e Celulose",
      "Pedagogia",
      "Petróleo e Gás",
      "Pilotagem Profissional de Aeronaves",
      "Processos Gerenciais",
      "Processos Metalúrgicos",
      "Processos Químicos",
      "Produção Audiovisual",
      "Produção Cênica",
      "Produção Cultural",
      "Produção de Bebidas",
      "Produção Editorial",
      "Produção Fonográfica",
      "Produção Multimídia",
      "Produção Publicitária",
      "Produção Sucroalcooleira",
      "Produção Têxtil",
      "Psicologia",
      "Psicopedagogia",
      "Publicidade e Propaganda",
      "Química",
      "Quiropraxia",
      "Radio, TV, Internet (Comunicação Audiovisual e Multimídia)",
      "Radiologia",
      "Redes de Computadores",
      "Relações Internacionais",
      "Relações Públicas",
      "Rochas Ornamentais",
      "Saneamento Ambiental",
      "Saúde",
      "Saúde Coletiva",
      "Secretariado",
      "Secretariado Executivo",
      "Segurança da Informação",
      "Segurança no Trabalho",
      "Segurança Pública",
      "Serviço Social",
      "Serviços Judiciários e Notariais",
      "Silvicultura",
      "Sistemas Biomédicos",
      "Sistemas da Informação",
      "Sistemas de Telecomunicações",
      "Sistemas Elétricos",
      "Sistemas Embarcados",
      "Sistemas para Internet",
      "Teatro",
      "Tecnologia da Informação",
      "Teologia",
      "Terapia Ocupacional",
      "Tradutor e Intérprete",
      "Transporte",
      "Turismo",
      "Zootecnia"
    ]
  }),
  computed: {
    color() {
      return this.$store.state.company.company.base_hexcolor || "#1551b1";
    }
  },
  methods: {
    closePage() {
      this.$router.back();
    },
    isDisabled() {
      return (
        this.payload.scholarity == "Ensino Fundamental" ||
        this.payload.scholarity == "Ensino Médio"
      );
    },
    showCourse() {
      return (
        this.payload.scholarity == "Ensino Técnico" ||
        this.payload.scholarity == "Ensino Superior" ||
        this.payload.scholarity == "Pós Graduação" ||
        this.payload.scholarity == "Mestrado" ||
        this.payload.scholarity == "Doutorado"
      );
    },
    async submit() {
      const isValid = await this.$refs.observer.validate();

      if (!isValid) return;

      this.$vs.loading({ text: "Enviando..." });

      const { company_label } = this.$router.history.current.params;

      this.$http
        .post(`api/v1/talent/${company_label}/user/talent?step=formations`, {
          formations: [
            {
              ...this.payload
            }
          ]
        })
        .then(response => {
          this.$vs.loading.close();

          if (this.payload.id) {
            this.$store.dispatch("formation/update", {
              ...this.payload
            });
          } else {
            this.$store.dispatch("formation/store", {
              ...this.payload,
              id: response.data.data.formations[0].id
            });
          }

          this.$router.back();
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            title: "Falha ao adicionar Formação",
            text: err.response.data.errors[0].errors,
            position: "top-right",
            time: 3200
          });

        });
    }
  },
  created() {
    this.$validator.extend(
      "monthYear",
      {
        getMessage: (field, params, data) =>
          (data && data.message) || "Verifique a data informada",
        validate: value =>
          new Promise(resolve => {
            if (parseInt(value.split("/")[0]) > 12)
              resolve({
                valid: false,
                data: {
                  message: `O mês ${
                    value.split("/")[0]
                  } informado não é válido!`
                }
              });
            else
              resolve({
                valid: true,
                data: { message: "" }
              });
          })
      },
      { hasTarget: true, immediate: false }
    );

    this.$validator.extend(
      "compareDate",
      {
        getMessage: (field, params, data) =>
          (data && data.message) || "Verifique as datas de início e saída",
        validate: value => {
          return new Promise(resolve => {
            if (!this.payload.is_current) {
              if (this.payload.from_date == "")
                resolve({
                  valid: false,
                  data: { message: "A data de início está vazia!" }
                });

              const splitFrom = "01/".concat(this.payload.from_date).split("/");
              const splitTo = "01/".concat(value).split("/");

              const monthReg = /0[1-9]|1[0-2]/;
              const yearReg = /(?:(?:19|20)[0-9]{2})/;

              if (!splitFrom[1].match(monthReg))
                resolve({
                  valid: false,
                  data: {
                    message: `O mês ${splitFrom[1]} informado na data de início não é válido!`
                  }
                });
              if (!splitTo[1].match(monthReg))
                resolve({
                  valid: false,
                  data: {
                    message: `O mês ${splitTo[1]} informado não é válido!`
                  }
                });

              if (!splitFrom[2].match(yearReg))
                resolve({
                  valid: false,
                  data: {
                    message: `O ano ${splitFrom[2]} informado na data de início não é válido!`
                  }
                });
              if (!splitTo[2].match(yearReg))
                resolve({
                  valid: false,
                  data: {
                    message: `O ano ${splitTo[2]} informado não é válido!`
                  }
                });

              const from = new Date(
                splitFrom[2],
                splitFrom[1] - 1,
                splitFrom[0]
              );
              const to = new Date(splitTo[2], splitTo[1] - 1, splitTo[0]);

              resolve({
                valid: isBefore(from, to),
                data: {
                  message: `${
                    isBefore(from, to)
                      ? ""
                      : "A data de finalização não pode ser menor que a data de início"
                  }`
                }
              });
            }
          });
        }
      },
      { hasTarget: true, immediate: false }
    );

    if (this.formation) {
      this.payload = {
        ...this.formation
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  padding: 16px;
  background: #fff;

  @media screen and (min-width: 768px) {
    padding: 36px;
  }
}

.closeBtn {
  display: flex;
  justify-content: flex-end;
}

.title {
  display: flex;
  justify-content: center;

  h1 {
    font-size: 20px;
  }
}

.content {
  padding: 16px 0;
  display: flex;
  justify-content: center;
}

.group {
  width: 100%;
  margin: 16px auto;

  @media only screen and (min-width: 1020px) {
    width: 70%;
  }
}

.button {
  width: 100%;
  display: flex;
  padding: 1rem;
  color: white;
  font-size: 1.25rem;
  border: 0;
  border-radius: 5px;
  justify-content: center;
  background-color: #1551b1;
}
</style>
